import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';

import ReactSignatureCanvas from 'react-signature-canvas';
import AddProductModal from './AddProductModal';
import axios from 'axios';
import { createApiData, fetchApiData } from '../../../../Components/Api';
import { useUserContext } from '../../../../hooks/UserContext';
import { Button, IconButton, InputField, Loader } from '../../../../Components/uielements';

import { getCvdUrl } from '../helper';
import {
  ModalGap,
  StyledSelect,
  StyledSelectLabel,
  StyledSelectWrapper,
} from '../../../../services/settings/appStyle/global.style';
import { ModalTitle } from '../../../../Components/uielements/modal/modal.style';
import {
  MultistepFormWrapper,
  ModalWrapper,
  TwoColumns,
  ButtonsWrapper,
  ModalButton,
  HeaderTitle,
  QuestionTitle,
  ClosedIcon,
} from '../Cvd.style';
import { ProductIntegrityDropdownValues, unitList } from '../constant';
import { AddPlusIcon } from '../../../../Components/icons';
import ChildModal from '../../../../Components/uielements/modal/childModal';
import AddProductTable from './AddProductTable';
import { IntlMessages } from '../../../../helper/langHelper';
import { useQuery, useQueryClient } from 'react-query';
import {
  getPremisesListByCompany,
  getPremisesListByManager,
} from '../../../../services/bioplus-services/cvd';
import { LoadingContent, LoadingModal } from '../../EmailTemplate/emailTemplate.style';

const AusAddCvdModal = ({
  setCvdFormData,
  cvdFormData,
  cvdModal,
  toggleCvdModal,
  isSubmitting,
  setIsSubmitting,
}) => {
  const userContext = useUserContext();
  const [expanded, setExpanded] = useState(0);
  const [addProductModal, setAddProductModal] = useState(false);
  const [companyList, setCompanyList] = useState(null);
  var signRef = {};

  const userRole = userContext?.company;
  const companyId = userRole?.companyId?.id;
  const roleId = userContext?.company?._id;

  const queryClient = useQueryClient();

  const premisesListByCompany = useQuery('premisesListByCompany', () =>
    companyId && userRole?.role === 'MANAGER'
      ? getPremisesListByManager(companyId, roleId)
      : getPremisesListByCompany(companyId)
  );

  useEffect(() => {
    if (typeof signRef.fromDataURL === 'function') {
      // do something
      signRef?.fromDataURL(cvdFormData['signature']);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expanded]);

  useEffect(() => {
    if (userContext?.company?.role === 'PARTNER' || userContext?.company?.role === 'ADMIN') {
      fetchApiData(
        '/partners/' + userContext?.company?.companyId?.id + '/companies?pageSize=100',
        localStorage.getItem('session')
      ).then((compData) => {
        setCompanyList(compData?.data?.data);
      });
    } else {
      setCvdFormData({ ...cvdFormData, companyName: userContext?.company?.companyId?.name });
      setCompanyList([
        {
          name: userContext?.company?.companyId?.name,
        },
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Cvd_url = getCvdUrl(process.env.REACT_APP_ENV);

  const handleCvdSubmit = async (event) => {
    event.preventDefault();

    // Guard against double-submit while a request is already in flight
    if (isSubmitting) return;

    setIsSubmitting(true);

    try {
      // Build the payload from a local copy instead of mutating the
      // cvdFormData state object directly — mutating state in place can
      // leave stale/incorrect values behind if the request fails or the
      // component re-renders before the request completes.
      const payloadForApi = {
        ...cvdFormData,
        companyName:
          userContext.company.role === 'OWNER'
            ? userContext?.company?.companyId?.name
            : cvdFormData.companyName,
        signature: cvdFormData.signature ? cvdFormData.signature.split(',')[1] : '',
        period: dayjs(cvdFormData.period).format('DD-MM-YYYY'),
      };

      // Send the CVD form data
      const response = await axios.post(Cvd_url, payloadForApi, {
        headers: { 'Access-Control-Allow-Origin': '*' },
      });

      if (response.data.code === '200') {
        const payload = {
          premiseId: payloadForApi.premiseId,
          premiseName: payloadForApi.vendorPIC,
          transporterName: payloadForApi.driverName,
          cvdName: dayjs(new Date()).format('DD-MM-YYYY') + ' ' + payloadForApi.companyName,
          content: response.data.data,
          propertyName: payloadForApi.companyName,
          buyerName: payloadForApi.buyerName,
          companyId: companyId,
          roleId,
        };

        const apiResponse = await createApiData('/cvd', payload, localStorage.getItem('session'));

        if (apiResponse.status === 200) {
          alert('CVD created successfully');
          userContext?.company?.role === 'MANAGER'
            ? await queryClient.invalidateQueries('managerListOfCvds')
            : await queryClient.invalidateQueries('listOfCvds');
          // toggleCvdModal (from the parent) resets cvdFormData to a fresh
          // copy, closes the modal, and bumps the remount key so this
          // component (and its expanded step / signature pad) starts clean
          // the next time it's opened.
          toggleCvdModal();
        } else {
          alert('Something went wrong. Please try again later.');
        }
      } else {
        const firstErrorKey = Object.keys(response.data.data)[0];
        alert(response.data.data[firstErrorKey]);
      }
    } catch (error) {
      alert('Something went wrong. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const toggleAddProductModal = () => {
    setAddProductModal((prev) => !prev);
  };

  const addProductModalProps = {
    addProductModal: addProductModal,
    toggleAddProductModal: toggleAddProductModal,
    setCvdFormData: setCvdFormData,
    cvdFormData: cvdFormData,
  };

  return (
    <>
      {premisesListByCompany && premisesListByCompany !== null && (
        <ChildModal isOpen={cvdModal} onClose={toggleCvdModal}>
          <ModalWrapper>
            <ModalTitle>
              <IntlMessages id="text.CVDForm" />
            </ModalTitle>
            <form onSubmit={handleCvdSubmit}>
              {expanded === 0 && (
                <MultistepFormWrapper>
                  <ModalGap>
                    <TwoColumns>
                      <InputField
                        Name={<IntlMessages id="input.label.name" />}
                        name="vd-name"
                        onChange={(e) => {
                          setCvdFormData({ ...cvdFormData, vendorName: e.target.value });
                        }}
                        defaultValue={cvdFormData['vendorName']}
                        required
                      />

                      <IntlMessages id="input.label.address" defaultValue="Address">
                        {(label) => (
                          <InputField
                            Name={label}
                            name="vd-address"
                            onChange={(e) => {
                              setCvdFormData({ ...cvdFormData, vendorAddress: e.target.value });
                            }}
                            defaultValue={cvdFormData['vendorAddress']}
                            required
                          />
                        )}
                      </IntlMessages>
                    </TwoColumns>
                    <TwoColumns>
                      <IntlMessages id="label.town" defaultValue="Town">
                        {(label) => (
                          <InputField
                            Name={label}
                            name="vd-town"
                            onChange={(e) => {
                              setCvdFormData({ ...cvdFormData, vendorTown: e.target.value });
                            }}
                            defaultValue={cvdFormData['vendorTown']}
                            required
                          />
                        )}
                      </IntlMessages>
                      <IntlMessages id="label.state" defaultValue="State">
                        {(label) => (
                          <InputField
                            Name={label}
                            name="vd-state"
                            onChange={(e) => {
                              setCvdFormData({ ...cvdFormData, vendorState: e.target.value });
                            }}
                            defaultValue={cvdFormData['vendorState']}
                            required
                          />
                        )}
                      </IntlMessages>
                    </TwoColumns>{' '}
                    <IntlMessages id="label.postal.code" defaultValue="Postal Code">
                      {(label) => (
                        <InputField
                          Name={label}
                          name="vd-postalcode"
                          defaultValue={cvdFormData['vendorPostalCode']}
                          required
                          onChange={(e) =>
                            setCvdFormData({ ...cvdFormData, vendorPostalCode: e.target.value })
                          }
                        />
                      )}
                    </IntlMessages>
                    <TwoColumns>
                      <IntlMessages id="table.col.mobile.no" defaultValue="Mobile No">
                        {(label) => (
                          <InputField
                            Name={label}
                            name="vd-mobile"
                            onChange={(e) => {
                              setCvdFormData({ ...cvdFormData, vendorContact: e.target.value });
                            }}
                            defaultValue={cvdFormData['vendorContact']}
                            required
                          />
                        )}
                      </IntlMessages>
                      <IntlMessages id="input.label.fax" defaultValue="Fax">
                        {(label) => (
                          <InputField
                            Name={label}
                            onChange={(e) => {
                              setCvdFormData({ ...cvdFormData, vendorFax: e.target.value });
                            }}
                            defaultValue={cvdFormData['vendorFax']}
                            name="vd-fax"
                          />
                        )}
                      </IntlMessages>
                    </TwoColumns>
                    <TwoColumns>
                      <IntlMessages id="input.label.email" defaultValue="Email">
                        {(label) => (
                          <InputField
                            Name={label}
                            name="vd-email"
                            onChange={(e) => {
                              setCvdFormData({ ...cvdFormData, vendorEmail: e.target.value });
                            }}
                            defaultValue={cvdFormData['vendorEmail']}
                            required
                          />
                        )}
                      </IntlMessages>
                      <IntlMessages
                        id="input.label.ngr"
                        defaultValue="National Grower Registration (NGR) No"
                      >
                        {(label) => (
                          <InputField
                            Name={label}
                            name="vd-ngr"
                            onChange={(e) => {
                              setCvdFormData({ ...cvdFormData, vendorNGR: e.target.value });
                            }}
                            defaultValue={cvdFormData['vendorNGR']}
                          />
                        )}
                      </IntlMessages>
                    </TwoColumns>
                    <TwoColumns>
                      {/* <IntlMessages id="input.label.premise.id" defaultValue="Premise Id">
                      {(label) => (
                        <InputField
                          Name={label}
                          name="vd-pic"
                          onChange={(e) => {
                            setCvdFormData({ ...cvdFormData, vendorPIC: e.target.value });
                          }}
                          defaultValue={cvdFormData['vendorPIC']}
                        />
                      )}
                    </IntlMessages> */}
                      <StyledSelectWrapper>
                        <StyledSelectLabel>
                          <IntlMessages id="input.label.premise.id" defaultValue="Premise Id" />
                        </StyledSelectLabel>
                        <StyledSelect
                          onChange={(e) => {
                            const selectedValue = JSON.parse(e.target.value);
                            setCvdFormData({
                              ...cvdFormData,
                              vendorPIC: selectedValue.propertyName,
                              premiseId: selectedValue.id,
                            });
                          }}
                        >
                          <option value="" disabled selected>
                            Select the premise
                          </option>
                          {premisesListByCompany &&
                            premisesListByCompany?.data?.map((option) => (
                              <option
                                key={option._id}
                                value={JSON.stringify({
                                  id: option._id,
                                  propertyName: option.propertyName,
                                })}
                              >
                                {option.propertyName}
                              </option>
                            ))}
                        </StyledSelect>
                      </StyledSelectWrapper>
                      <IntlMessages
                        id="input.label.vendor.contact"
                        defaultValue="Vendor contract/reference number"
                      >
                        {(label) => (
                          <InputField
                            Name={label}
                            name="vd-vcr"
                            onChange={(e) => {
                              setCvdFormData({ ...cvdFormData, vendorReference: e.target.value });
                            }}
                            defaultValue={cvdFormData['vendorReference']}
                          />
                        )}
                      </IntlMessages>
                    </TwoColumns>
                  </ModalGap>
                </MultistepFormWrapper>
              )}
              {expanded === 1 && (
                <MultistepFormWrapper>
                  <ModalGap>
                    <TwoColumns>
                      <IntlMessages id="input.label.name" defaultValue="name">
                        {(label) => (
                          <InputField
                            Name={label}
                            name="bd-name"
                            onChange={(e) => {
                              setCvdFormData({ ...cvdFormData, buyerName: e.target.value });
                            }}
                            defaultValue={cvdFormData['buyerName']}
                            required
                          />
                        )}
                      </IntlMessages>
                      <IntlMessages id="input.label.address" defaultValue="Address">
                        {(label) => (
                          <InputField
                            Name={label}
                            name="bd-address"
                            onChange={(e) => {
                              setCvdFormData({ ...cvdFormData, buyerAddress: e.target.value });
                            }}
                            defaultValue={cvdFormData['buyerAddress']}
                            required
                          />
                        )}
                      </IntlMessages>
                    </TwoColumns>
                    <TwoColumns>
                      <IntlMessages id="label.town" defaultValue="Town">
                        {(label) => (
                          <InputField
                            Name={label}
                            name="bd-town"
                            onChange={(e) => {
                              setCvdFormData({ ...cvdFormData, buyerTown: e.target.value });
                            }}
                            defaultValue={cvdFormData['buyerTown']}
                            required
                          />
                        )}
                      </IntlMessages>
                      <IntlMessages id="label.state" defaultValue="State">
                        {(label) => (
                          <InputField
                            Name={label}
                            name="bd-state"
                            onChange={(e) => {
                              setCvdFormData({ ...cvdFormData, buyerState: e.target.value });
                            }}
                            defaultValue={cvdFormData['buyerState']}
                            required
                          />
                        )}
                      </IntlMessages>
                    </TwoColumns>{' '}
                    <IntlMessages id="label.postal.code" defaultValue="Postal Code">
                      {(label) => (
                        <InputField
                          Name={label}
                          name="bd-postalcode"
                          defaultValue={cvdFormData['buyerPostalCode']}
                          required
                          onChange={(e) =>
                            setCvdFormData({ ...cvdFormData, buyerPostalCode: e.target.value })
                          }
                        />
                      )}
                    </IntlMessages>
                    <TwoColumns>
                      <IntlMessages id="input.label.mobile.no" defaultValue="Mobile No">
                        {(label) => (
                          <InputField
                            Name={label}
                            name="bd-mobile"
                            onChange={(e) => {
                              setCvdFormData({ ...cvdFormData, buyerContact: e.target.value });
                            }}
                            defaultValue={cvdFormData['buyerContact']}
                            required
                          />
                        )}
                      </IntlMessages>
                      <IntlMessages id="input.label.fax" defaultValue="Fax">
                        {(label) => (
                          <InputField
                            Name={label}
                            name="bd-fax"
                            onChange={(e) => {
                              setCvdFormData({ ...cvdFormData, buyerFax: e.target.value });
                            }}
                            defaultValue={cvdFormData['buyerFax']}
                          />
                        )}
                      </IntlMessages>
                    </TwoColumns>
                    <TwoColumns>
                      <IntlMessages id="input.label.email" defaultValue="Email">
                        {(label) => (
                          <InputField
                            Name={label}
                            name="bd-email"
                            onChange={(e) => {
                              setCvdFormData({ ...cvdFormData, buyerEmail: e.target.value });
                            }}
                            defaultValue={cvdFormData['buyerEmail']}
                            required
                          />
                        )}
                      </IntlMessages>
                      <IntlMessages
                        id="input.label.ngr"
                        defaultValue="National Grower Registration (NGR) No"
                      >
                        {(label) => (
                          <InputField
                            Name={label}
                            name="bd-ngr"
                            onChange={(e) => {
                              setCvdFormData({ ...cvdFormData, buyerNGR: e.target.value });
                            }}
                            defaultValue={cvdFormData['buyerNGR']}
                          />
                        )}
                      </IntlMessages>
                    </TwoColumns>
                    <TwoColumns>
                      {/* <IntlMessages id="input.label.premise.id" defaultValue="Premise Id">
                      {(label) => (
                        <InputField
                          Name={label}
                          name="bd-pic"
                          onChange={(e) => {
                            setCvdFormData({ ...cvdFormData, buyerPIC: e.target.value });
                          }}
                          defaultValue={cvdFormData['buyerPIC']}
                        />
                      )}
                    </IntlMessages> */}
                      <StyledSelectWrapper>
                        <StyledSelectLabel>
                          <IntlMessages id="input.label.premise.id" defaultValue="Premise Id" />
                        </StyledSelectLabel>
                        <StyledSelect
                          onChange={(e) => {
                            setCvdFormData({ ...cvdFormData, buyerPIC: e.target.value });
                          }}
                        >
                          <option value="" disabled selected>
                            Select the premise
                          </option>
                          {premisesListByCompany &&
                            premisesListByCompany?.data?.map((option) => (
                              <option key={option._id} value={option.propertyName}>
                                {option.propertyName}
                              </option>
                            ))}
                        </StyledSelect>
                      </StyledSelectWrapper>
                      <IntlMessages
                        id="input.label.buyer.contract.no"
                        defaultValue="Buyers Contract No."
                      >
                        {(label) => (
                          <InputField
                            Name={label}
                            name="bd-bcn"
                            onChange={(e) => {
                              setCvdFormData({ ...cvdFormData, buyerReference: e.target.value });
                            }}
                            defaultValue={cvdFormData['buyerReference']}
                          />
                        )}
                      </IntlMessages>
                    </TwoColumns>
                  </ModalGap>
                </MultistepFormWrapper>
              )}
              {expanded === 2 && (
                <MultistepFormWrapper>
                  <ModalGap>
                    <IntlMessages id="input.label.driver.name" defaultValue="Driver Name">
                      {(label) => (
                        <InputField
                          Name={label}
                          name="tr-driverName"
                          onChange={(e) => {
                            setCvdFormData({ ...cvdFormData, driverName: e.target.value });
                          }}
                          defaultValue={cvdFormData['driverName']}
                        />
                      )}
                    </IntlMessages>
                    <IntlMessages id="input.label.email" defaultValue="Email">
                      {(label) => (
                        <InputField
                          Name={label}
                          name="tr-email"
                          onChange={(e) => {
                            setCvdFormData({ ...cvdFormData, driverEmail: e.target.value });
                          }}
                          defaultValue={cvdFormData['driverEmail']}
                        />
                      )}
                    </IntlMessages>
                    <IntlMessages id="input.label.mobile.no" defaultValue="Mobile No">
                      {(label) => (
                        <InputField
                          Name={label}
                          name="tr-mobile"
                          onChange={(e) => {
                            setCvdFormData({ ...cvdFormData, driverContact: e.target.value });
                          }}
                          defaultValue={cvdFormData['driverContact']}
                        />
                      )}
                    </IntlMessages>
                    <IntlMessages id="table.col.company" defaultValue="Entity">
                      {(label) => (
                        <InputField
                          Name={label}
                          name="tr-company"
                          onChange={(e) => {
                            setCvdFormData({ ...cvdFormData, driverCompanyName: e.target.value });
                          }}
                          defaultValue={cvdFormData['driverCompanyName']}
                        />
                      )}
                    </IntlMessages>
                    <IntlMessages id="input.label.registration" defaultValue="Registration">
                      {(label) => (
                        <InputField
                          Name={label}
                          name="tr-registeration"
                          style={{
                            textTransform: 'uppercase',
                          }}
                          onChange={(e) => {
                            setCvdFormData({
                              ...cvdFormData,
                              registration: e.target.value.toUpperCase(),
                            });
                          }}
                          defaultValue={cvdFormData['registration']}
                        />
                      )}
                    </IntlMessages>
                  </ModalGap>
                </MultistepFormWrapper>
              )}
              {expanded === 3 && (
                <MultistepFormWrapper>
                  <ModalGap>
                    <TwoColumns>
                      <IntlMessages id="input.label.commodity.one" defaultValue="Commodity 1">
                        {(label) => (
                          <InputField
                            Name={label}
                            name="cd-commodity"
                            onChange={(e) => {
                              setCvdFormData({ ...cvdFormData, commodity1: e.target.value });
                            }}
                            defaultValue={cvdFormData['commodity1']}
                          />
                        )}
                      </IntlMessages>
                      <IntlMessages id="input.label.commodity.two" defaultValue="Commodity 2">
                        {(label) => (
                          <InputField
                            Name={label}
                            name="cd-commodity2"
                            onChange={(e) => {
                              setCvdFormData({ ...cvdFormData, commodity2: e.target.value });
                            }}
                            defaultValue={cvdFormData['commodity2']}
                          />
                        )}
                      </IntlMessages>
                    </TwoColumns>
                    <TwoColumns>
                      <IntlMessages id="input.label.variety.one" defaultValue="Variety 1">
                        {(label) => (
                          <InputField
                            Name={label}
                            name="cd-variety1"
                            onChange={(e) => {
                              setCvdFormData({ ...cvdFormData, variety1: e.target.value });
                            }}
                            defaultValue={cvdFormData['variety1']}
                            required
                          />
                        )}
                      </IntlMessages>
                      <IntlMessages id="input.label.variety.two" defaultValue="Variety 2">
                        {(label) => (
                          <InputField
                            Name={label}
                            name="cd-variety2"
                            onChange={(e) => {
                              setCvdFormData({ ...cvdFormData, variety2: e.target.value });
                            }}
                            defaultValue={cvdFormData['variety2']}
                          />
                        )}
                      </IntlMessages>
                    </TwoColumns>
                    <TwoColumns>
                      <IntlMessages id="input.label.quantity.one" defaultValue="Quantity 1">
                        {(label) => (
                          <InputField
                            Name={label}
                            name="cd-quantity1"
                            type="number"
                            onChange={(e) => {
                              setCvdFormData({ ...cvdFormData, quantity1: e.target.value });
                            }}
                            defaultValue={cvdFormData['quantity1']}
                            required
                          />
                        )}
                      </IntlMessages>
                      <IntlMessages id="input.label.quantity.two" defaultValue="Quantity 2">
                        {(label) => (
                          <InputField
                            Nme={label}
                            type="number"
                            name="cd-quantity2"
                            onChange={(e) => {
                              setCvdFormData({ ...cvdFormData, quantity2: e.target.value });
                            }}
                            defaultValue={cvdFormData['quantity2']}
                          />
                        )}
                      </IntlMessages>
                    </TwoColumns>
                    <TwoColumns>
                      <StyledSelectWrapper>
                        <StyledSelectLabel>
                          <IntlMessages id="text.unit" />
                        </StyledSelectLabel>
                        <StyledSelect
                          name="cd-unit1"
                          defaultValue={cvdFormData['unit1']}
                          onChange={(e) => {
                            setCvdFormData({ ...cvdFormData, unit1: e.target.value });
                          }}
                        >
                          {unitList?.map((option) => (
                            <option key={option.value} value={option.label}>
                              {option.label}
                            </option>
                          ))}
                        </StyledSelect>
                      </StyledSelectWrapper>
                      <StyledSelectWrapper>
                        <StyledSelectLabel>
                          <IntlMessages id="text.unit" />
                        </StyledSelectLabel>
                        <StyledSelect
                          name="cd-unit2"
                          onChange={(e) => {
                            setCvdFormData({ ...cvdFormData, unit2: e.target.value });
                          }}
                          defaultValue={cvdFormData['unit2']}
                        >
                          {unitList?.map((option) => (
                            <option key={option.value} value={option.label}>
                              {option.label}
                            </option>
                          ))}
                        </StyledSelect>
                      </StyledSelectWrapper>
                    </TwoColumns>
                    <TwoColumns>
                      <IntlMessages id="input.label.total.qty" defaultValue="Total Quantity">
                        {(label) => (
                          <InputField
                            Name={label}
                            name="cd-totalQuantity"
                            value={
                              parseInt(
                                cvdFormData['quantity1'] !== '' ? cvdFormData['quantity1'] : 0
                              ) +
                              parseInt(
                                cvdFormData['quantity2'] !== '' ? cvdFormData['quantity2'] : 0
                              )
                            }
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        )}
                      </IntlMessages>

                      <InputField
                        type="date"
                        Name={<IntlMessages id="input.label.delivery" />}
                        format="DD/MM/YYYY"
                        name="cd-deliveryPeriod"
                        onChange={(e) => {
                          setCvdFormData({ ...cvdFormData, period: e.target.value });
                        }}
                        defaultValue={cvdFormData['period']}
                      />
                    </TwoColumns>
                  </ModalGap>
                </MultistepFormWrapper>
              )}
              {expanded === 4 && (
                <MultistepFormWrapper>
                  <ModalGap>
                    <HeaderTitle>
                      <IntlMessages id="text.partA.one" />
                    </HeaderTitle>
                    <QuestionTitle>
                      <IntlMessages id="text.partA.two" />
                    </QuestionTitle>
                    <StyledSelectWrapper>
                      <StyledSelectLabel>
                        <IntlMessages id="text.selectAnOption" />
                      </StyledSelectLabel>
                      <StyledSelect
                        onChange={(e) => {
                          setCvdFormData({ ...cvdFormData, sourceCheck: e.target.value });
                        }}
                        defaultValue={
                          cvdFormData['sourceCheck'] === ''
                            ? 'Select an Option'
                            : cvdFormData['sourceCheck']
                        }
                        required
                      >
                        {ProductIntegrityDropdownValues?.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </StyledSelect>
                    </StyledSelectWrapper>

                    <QuestionTitle>
                      <IntlMessages id="text.partA.three" />
                    </QuestionTitle>
                    <StyledSelectWrapper>
                      <StyledSelectLabel>
                        <IntlMessages id="text.selectAnOption" />
                      </StyledSelectLabel>
                      <StyledSelect
                        onChange={(e) => {
                          setCvdFormData({ ...cvdFormData, materialCheck: e.target.value });
                        }}
                        defaultValue={
                          cvdFormData['materialCheck'] === ''
                            ? 'Select an Option'
                            : cvdFormData['materialCheck']
                        }
                        required
                      >
                        {[
                          { value: '0', label: 'Yes' },
                          { value: '1', label: 'No' },
                        ]?.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </StyledSelect>
                    </StyledSelectWrapper>

                    <QuestionTitle>
                      <IntlMessages id="text.partA.four" />
                    </QuestionTitle>
                    <StyledSelectWrapper>
                      <StyledSelectLabel>
                        <IntlMessages id="text.selectAnOption" />
                      </StyledSelectLabel>
                      <StyledSelect
                        onChange={(e) => {
                          setCvdFormData({ ...cvdFormData, gmoCheck: e.target.value });
                        }}
                        defaultValue={
                          cvdFormData['gmoCheck'] === ''
                            ? 'Select an Option'
                            : cvdFormData['gmoCheck']
                        }
                        required
                      >
                        {[
                          { value: '0', label: <IntlMessages id="gmoCheck.dropdown.one" /> },
                          { value: '1', label: <IntlMessages id="gmoCheck.dropdown.two" /> },
                          { value: '2', label: <IntlMessages id="gmoCheck.dropdown.three" /> },
                        ]?.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </StyledSelect>
                    </StyledSelectWrapper>
                  </ModalGap>
                </MultistepFormWrapper>
              )}
              {expanded === 5 && (
                <MultistepFormWrapper>
                  <ModalGap>
                    <HeaderTitle>
                      <IntlMessages id="text.partB.title" />
                    </HeaderTitle>
                    <QuestionTitle>
                      <IntlMessages id="text.partB.one" />
                    </QuestionTitle>
                    <StyledSelectWrapper>
                      <StyledSelectLabel>
                        <IntlMessages id="text.selectAnOption" />
                      </StyledSelectLabel>
                      <StyledSelect
                        onChange={(e) => {
                          setCvdFormData({ ...cvdFormData, chemicalCheck: e.target.value });
                        }}
                        defaultValue={
                          cvdFormData['chemicalCheck'] === ''
                            ? 'Select an Option'
                            : cvdFormData['chemicalCheck']
                        }
                        required
                      >
                        <option value="Select an Option" selected disabled>
                          <IntlMessages id="text.selectAnOption" />
                        </option>
                        {[
                          { value: '1', label: 'Yes' },
                          { value: '0', label: 'No' },
                        ]?.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </StyledSelect>
                    </StyledSelectWrapper>

                    {+cvdFormData['chemicalCheck'] === 1 && cvdFormData?.chemicals?.length > 0 && (
                      <AddProductTable
                        data={cvdFormData?.chemicals}
                        onDelete={(data, index) =>
                          setCvdFormData({
                            ...cvdFormData,
                            chemicals: cvdFormData.chemicals.filter((a, i) => i !== index),
                          })
                        }
                      />
                    )}
                    <IconButton
                      text={<IntlMessages id="button.text.addAnotherProduct" />}
                      type="button"
                      icon={<AddPlusIcon />}
                      style={{ width: 'fit-content', margin: 'auto', marginTop: '10px' }}
                      hidden={cvdFormData['chemicalCheck'] === 1 ? false : true}
                      onClick={() => toggleAddProductModal()}
                    />

                    <QuestionTitle>
                      <IntlMessages id="text.partB.two" />
                    </QuestionTitle>
                    <StyledSelectWrapper>
                      <StyledSelectLabel>
                        {' '}
                        <IntlMessages id="text.selectAnOption" />
                      </StyledSelectLabel>
                      <StyledSelect
                        // defaultValue={cvdFormData['qaCheck'] === '' ? 'Select an Option' : cvdFormData['qaCheck']}
                        onChange={(e) =>
                          setCvdFormData({ ...cvdFormData, qaCheck: e.target.value })
                        }
                        required
                      >
                        {[
                          { value: '2', label: <IntlMessages id="text.selectAnOption" /> },
                          { value: '1', label: 'Yes' },
                          { value: '0', label: 'No' },
                        ]?.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                            disabled={option.value === '2'}
                            selected={option.value === '2'}
                          >
                            {option.label}
                          </option>
                        ))}
                      </StyledSelect>
                    </StyledSelectWrapper>
                    {+cvdFormData['qaCheck'] === 1 && (
                      <>
                        <TwoColumns>
                          <InputField
                            Name="QA Program"
                            name="cu-qa-program"
                            onChange={(e) =>
                              setCvdFormData({ ...cvdFormData, qaProgram: e.target.value })
                            }
                            defaultValue={cvdFormData['qaProgram']}
                          />
                          <InputField
                            Name="Accreditation/ Certification Number"
                            name="cd-accno"
                            onChange={(e) =>
                              setCvdFormData({ ...cvdFormData, certificateNumber: e.target.value })
                            }
                            defaultValue={
                              cvdFormData['certificateNumber'] !== ''
                                ? cvdFormData['cerificateNumber']
                                : ''
                            }
                          />
                        </TwoColumns>
                      </>
                    )}
                    <QuestionTitle>
                      <IntlMessages id="text.partB.three" />
                    </QuestionTitle>
                    <StyledSelectWrapper>
                      <StyledSelectLabel>
                        <IntlMessages id="text.selectAnOption" />
                      </StyledSelectLabel>
                      <StyledSelect
                        onChange={(e) => {
                          setCvdFormData({ ...cvdFormData, cvdCheck: e.target.value });
                        }}
                        defaultValue={
                          cvdFormData['cvdCheck'] === ''
                            ? 'Select an Option'
                            : cvdFormData['cvdCheck']
                        }
                        required
                      >
                        {[
                          { value: '2', label: <IntlMessages id="text.selectAnOption" /> },
                          { value: '1', label: 'Yes' },
                          { value: '0', label: 'No' },
                        ]?.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                            disabled={option.value === '2'}
                            selected={option.value === '2'}
                          >
                            {option.label}
                          </option>
                        ))}
                      </StyledSelect>
                    </StyledSelectWrapper>
                    <QuestionTitle>
                      <IntlMessages id="text.partB.four" />
                    </QuestionTitle>
                    {cvdFormData?.cropList?.map((data, index) => (
                      <div style={{ position: 'relative' }}>
                        <InputField
                          key={index}
                          name="cu-7"
                          defaultValue={data.cropName}
                          onChange={(e) =>
                            setCvdFormData({
                              ...cvdFormData,
                              cropList: cvdFormData.cropList.map((item, i) =>
                                i === index ? { ...item, cropName: e.target.value } : item
                              ),
                            })
                          }
                          require
                        />
                        <ClosedIcon
                          onClick={() => {
                            setCvdFormData({
                              ...cvdFormData,
                              cropList: cvdFormData.cropList.filter((d, i) => i !== index),
                            });
                          }}
                        />
                      </div>
                    ))}
                    <IconButton
                      type="button"
                      icon={<AddPlusIcon />}
                      text={<IntlMessages id="button.text.add" />}
                      onClick={() => {
                        setCvdFormData((prev) => ({
                          ...prev,
                          cropList: [...prev.cropList, { cropName: '' }],
                        }));
                      }}
                      style={{ width: 'fit-content', margin: 'auto', marginTop: '10px' }}
                    />

                    <QuestionTitle>
                      <IntlMessages id="text.partB.five" />
                    </QuestionTitle>
                    <StyledSelectWrapper>
                      <StyledSelectLabel>
                        <IntlMessages id="text.selectAnOption" />
                      </StyledSelectLabel>
                      <StyledSelect
                        onChange={(e) => {
                          setCvdFormData({ ...cvdFormData, riskCheck: e.target.value });
                        }}
                        // defaultValue={cvdFormData['riskCheck'] === '' ? 'Select an Option' : cvdFormData['riskCheck']}
                        required
                      >
                        {[
                          { value: '3', label: <IntlMessages id="text.selectAnOption" /> },
                          { value: '1', label: 'Yes' },
                          { value: '0', label: 'No' },
                          { value: '2', label: 'N/A' },
                        ]?.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                            disabled={option.value === '3'}
                            selected={option.value === '3'}
                          >
                            {option.label}
                          </option>
                        ))}
                      </StyledSelect>
                    </StyledSelectWrapper>
                    {+cvdFormData['riskCheck'] === 1 && (
                      <InputField
                        Name="Risk Assesment Results"
                        name="cu-risk-assesment-results"
                        onChange={(e) =>
                          setCvdFormData({ ...cvdFormData, riskAssesment: e.target.value })
                        }
                        defaultValue={cvdFormData['riskAssesment']}
                      />
                    )}
                    <QuestionTitle>
                      <IntlMessages id="text.partB.six" />
                    </QuestionTitle>
                    <StyledSelectWrapper>
                      <StyledSelectLabel>
                        <IntlMessages id="text.selectAnOption" />
                      </StyledSelectLabel>
                      <StyledSelect
                        onChange={(e) => {
                          setCvdFormData({ ...cvdFormData, nataCheck: e.target.value });
                        }}
                        // defaultValue={cvdFormData['nataCheck'] === '' ? 'Select an Option' : cvdFormData['nataCheck']}
                        required
                      >
                        {[
                          { value: '2', label: <IntlMessages id="text.selectAnOption" /> },
                          { value: '1', label: 'Yes' },
                          { value: '0', label: 'No' },
                        ]?.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                            disabled={option.value === '2'}
                            selected={option.value === '2'}
                          >
                            {option.label}
                          </option>
                        ))}
                      </StyledSelect>
                    </StyledSelectWrapper>
                    {+cvdFormData['nataCheck'] === 1 && (
                      <IntlMessages id="input.label.testResults" defaultValue="Test Results">
                        {(label) => (
                          <InputField
                            Name={label}
                            name="cu-test-results"
                            onChange={(e) =>
                              setCvdFormData({ ...cvdFormData, testResult: e.target.value })
                            }
                            defaultValue={cvdFormData['testResult']}
                          />
                        )}
                      </IntlMessages>
                    )}
                  </ModalGap>
                </MultistepFormWrapper>
              )}
              {expanded === 6 && (
                <MultistepFormWrapper>
                  <ModalGap>
                    <InputField
                      Name={<IntlMessages id="input.label.name" />}
                      name="sd-name"
                      onChange={(e) => {
                        setCvdFormData({ ...cvdFormData, vendorName: e.target.value });
                      }}
                      defaultValue={cvdFormData['vendorName']}
                      fullWidth
                    />
                    <StyledSelectWrapper>
                      <StyledSelectLabel>
                        <IntlMessages id="input.label.company.name" />
                      </StyledSelectLabel>
                      <StyledSelect
                        name="sd-organization"
                        onChange={(e) => {
                          setCvdFormData({ ...cvdFormData, companyName: e.target.value });
                        }}
                        defaultValue={
                          userContext.company.role === 'OWNER'
                            ? userContext.company.companyName
                            : ''
                        }
                        required
                      >
                        {companyList?.map((option) => (
                          <option
                            key={option.name}
                            value={option.name}
                            onClick={(e) =>
                              setCvdFormData({ ...cvdFormData, companyName: e.target.textContent })
                            }
                          >
                            {option.name}
                          </option>
                        ))}
                      </StyledSelect>
                    </StyledSelectWrapper>

                    <HeaderTitle color="warning">
                      <IntlMessages id="text.info" />
                    </HeaderTitle>
                    <QuestionTitle>
                      <IntlMessages
                        id="text.declare"
                        values={{
                          name: cvdFormData['vendorName'],
                          company: userContext?.company?.companyId?.name,
                        }}
                      />
                    </QuestionTitle>
                    <QuestionTitle>
                      <IntlMessages id="text.self.declare.one" />
                    </QuestionTitle>
                    <QuestionTitle>
                      <IntlMessages id="text.self.declare.two" />
                    </QuestionTitle>
                    <QuestionTitle>
                      <IntlMessages id="text.self.declare.three" />
                    </QuestionTitle>
                    <QuestionTitle>
                      <IntlMessages id="text.self.declare.four" />
                    </QuestionTitle>
                    <div style={{ display: 'grid', gap: '10px' }}>
                      <HeaderTitle>
                        <IntlMessages id="text.signature" />:
                      </HeaderTitle>
                      <ReactSignatureCanvas
                        penColor="white"
                        ref={(ref) => {
                          signRef = ref;
                        }}
                        onEnd={(e) => {
                          setCvdFormData({ ...cvdFormData, signature: signRef.toDataURL() });
                        }}
                        canvasProps={{
                          width: 600,
                          height: 200,
                          className: 'sigCanvas',
                          style: {
                            border: '2px solid green',
                            borderRadius: '10px',
                          },
                        }}
                      />
                    </div>
                    <Button
                      onClick={() => {
                        signRef.clear();
                        setCvdFormData({ ...cvdFormData, signature: '' });
                      }}
                      variant="contained"
                      style={{ maxWidth: 'fit-content' }}
                      disabled={isSubmitting}
                    >
                      <IntlMessages id="button.text.clearSignature" />
                    </Button>
                  </ModalGap>
                </MultistepFormWrapper>
              )}

              {isSubmitting && (
                <LoadingModal style={{ position: 'absolute' }}>
                  <LoadingContent style={{ border: 'none' }}>
                    <Loader loadingText="Submitting the eDEC's. Please wait a moment..." />
                  </LoadingContent>
                </LoadingModal>
              )}

              <ButtonsWrapper>
                {expanded > 0 && (
                  <ModalButton
                    onClick={() => setExpanded((prev) => prev - 1)}
                    disabled={isSubmitting}
                  >
                    <IntlMessages id="button.text.back" />
                  </ModalButton>
                )}
                <ModalButton varient="outline" onClick={toggleCvdModal} disabled={isSubmitting}>
                  <IntlMessages id="modal.button.close" />
                </ModalButton>
                {expanded < 6 && (
                  <ModalButton
                    onClick={() => setExpanded((prev) => prev + 1)}
                    disabled={isSubmitting}
                  >
                    <IntlMessages id="nav.drop.down.next" />
                  </ModalButton>
                )}
                {expanded === 6 && (
                  <ModalButton type="submit" disabled={isSubmitting}>
                    {isSubmitting ? (
                      <IntlMessages id="modal.button.submitting" defaultMessage="Submitting..." />
                    ) : (
                      <IntlMessages id="modal.button.submit" />
                    )}
                  </ModalButton>
                )}
              </ButtonsWrapper>
            </form>
          </ModalWrapper>
        </ChildModal>
      )}

      {addProductModal ? <AddProductModal {...addProductModalProps} /> : null}
    </>
  );
};

export default AusAddCvdModal;
